import {RichContent, isRichContent} from '@wix/ricos';

export const getRicoRichContent = (content: string) => {
  try {
    const richContent = JSON.parse(content) as RichContent;
    /* istanbul ignore next: tested in sled */
    return isRichContent(richContent) ? richContent : null;
  } catch {
    return null;
  }
};

export const isRicoRichContent = (content: string) => {
  return getRicoRichContent(content) !== null;
};
